$(() => {
  const linkNavs = $('.human-capital__navbar-nav');
  if (linkNavs.length) {
    linkNavs.each(function hideAnchorLinksInNavThatAreNotOnPage() {
      const links = $(this).find('a');
      links.each(function handleLink() {
        const link = $(this);
        const isAnchorLink = link.attr('href').startsWith('#');
        if (!isAnchorLink || (isAnchorLink && $(link.attr('href')).length)) {
          link.parent().show();
        }
      });
    });
  }
});
